import WithRender from "../../templates/imageEditorGalleries/imageEditorLocalImages.html";
import { mapGetters } from "vuex";

import ImageEditorGallery from "../imageEditorGalleries/ImageEditorGallery";

export default WithRender({
  components: {
    appImageEditorGallery: ImageEditorGallery
  },
  computed: {
    ...mapGetters({ items: "getImageGalleryItems" })
  }
});
